import { useEffect, useRef, useState } from "react"
import { Button, Empty, Input } from "antd"
import { SendOutlined } from "@ant-design/icons"
import { renderDate } from "../../Utils/utils"
import "./HelpChat.scss"

const HelpChat = ({
  thread,
  staffView = false,
  sending = false,
  onSend,
  placeholder = "Write a message…",
  draftValue,
  onDraftValue,
  extraActions = null,
}) => {
  const [localDraft, setLocalDraft] = useState("")
  const draft = draftValue !== undefined ? draftValue : localDraft
  const setDraft = (value) => {
    if (onDraftValue) onDraftValue(value)
    if (draftValue === undefined) setLocalDraft(value)
  }
  const endRef = useRef(null)
  const messages = thread?.messages || []

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages.length, thread?._id])

  const submit = async () => {
    const text = draft.trim()
    if (!text || sending || !onSend) return
    setDraft("")
    await onSend(text)
  }

  return (
    <div className="help-chat">
      <div className="help-chat__messages">
        {!messages.length ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Start the conversation. IT replies in this chat."
          />
        ) : (
          messages.map((msg, index) => {
            const mine = staffView ? msg.from === "it" : msg.from === "user"
            return (
              <div
                key={msg._id || `${msg.createdAt}-${index}`}
                className={`help-chat__row ${mine ? "help-chat__row--mine" : ""}`}
              >
                <div className="help-chat__bubble">
                  <div className="help-chat__meta">
                    {mine ? "You" : msg.name || (msg.from === "it" ? "IT" : "User")}
                    <span>{renderDate(msg.createdAt)}</span>
                  </div>
                  <div className="help-chat__text">{msg.text}</div>
                </div>
              </div>
            )
          })
        )}
        <div ref={endRef} />
      </div>
      <div className="help-chat__composer">
        <Input.TextArea
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          placeholder={placeholder}
          autoSize={{ minRows: 2, maxRows: 4 }}
          maxLength={2000}
          disabled={sending}
          onPressEnter={(event) => {
            if (event.shiftKey) return
            event.preventDefault()
            submit()
          }}
        />
        {extraActions}
        <Button
          type="primary"
          icon={<SendOutlined />}
          loading={sending}
          disabled={!draft.trim()}
          onClick={submit}
        >
          Send
        </Button>
      </div>
      {thread?.status === "closed" ? (
        <div className="help-chat__closed">
          {staffView
            ? "This chat is closed. Send a reply to reopen it, or use Reopen."
            : "This chat is closed. Send a message to reopen it from My workspace."}
        </div>
      ) : (
        <div className="help-chat__hint">Enter to send · Shift+Enter for a new line</div>
      )}
    </div>
  )
}

export default HelpChat
